import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { ApiError, httpClient } from '@/api/http-client'

export async function startPreProgrammedDeal(dealKey: string) {
  const response = await httpClient('accounting-dealer').put<void>(
    `/v3/deal/${dealKey}/pre-programmed/start`,
    undefined,
    { ignoreErrorToast: true },
  )

  return response.data
}

export function useStartPreProgrammedDeal(
  options?: UseMutationOptions<unknown, ApiError, string, unknown>,
) {
  return useMutation({
    mutationFn: startPreProgrammedDeal,
    ...options,
  })
}
